// util classes
const setAmount = (state, product, quantity) => {
  let existingProduct = [...state.products].find(
    (item) => item.id === product.id,
  );

  if (existingProduct) {
    let filteredArr = state.products.filter((item) => item.id !== product.id);
    console.log(filteredArr);
    if (quantity >= 1) {
      return [
        ...filteredArr,
        {
          ...existingProduct,
          quantity: Number(quantity),
        },
      ];
    } else if (quantity < 1) {
      return [...filteredArr];
    }
  }

  return [...state.products, { ...product, quantity: 1 }];
};

const orderReducer = (
  state = {
    company: undefined,
    retailers: [],
    orderDetails: [],
    retailerListForOrderDetails: [],
    productPriceVisibility: false,
    orderForRetailerAndAssociate: {},
    productsForRetailerAndAssociate: [],
    dispatchStatusTab: { active: false, activeTabName: 'Pending' },
    orderTab: { active: false, activeTabName: 'AllOrders' },
    dataForAddUserInDispatchPlanning: {
      buyerId: 1,
      fromOrderDetails: false,
      editUserData: {},
    },
    EWRProductForOrder: [],
    skuMaster: [],
    cart: [],
    deliveryAddressDetails: {},
    company_id: null,
    distributor: null,
    sec_cart: [],
    companyDetails:{},
    cashDiscountConfig:{},
    buyerDetails: {}
  },
  action,
) => {
  switch (action.type) {
    // Old Checkout might need to remove
    case 'SET_PRODUCT_QUANITY':
      let setResult = setAmount(
        state,
        action.data.product,
        action.data.quantity,
      );
      return { ...state, products: setResult };
    case 'CLEAR_ORDER':
      return {
        ...state,
        products: [],
        company: undefined,
      };

    // Products and retailer for new Products
    case 'SET_PRODUCTS':
      const newRetailerObject = [
        ...state.retailers.filter(
          (retailer) => retailer.key !== action.data.key,
        ),
        action.data.retailer,
      ];
      return {
        ...state,
        retailers: newRetailerObject,
      };
    case 'REMOVE_RETAILER_PRODUCT':
      const retailerObjectWithProductRemoved = [
        ...state.retailers.filter(
          (retailer) => retailer.key !== action.data.key,
        ),
        action.data.retailer,
      ];
      return {
        ...state,
        retailers: retailerObjectWithProductRemoved,
      };
    case 'ADD_RETAILER':
      return {
        ...state,
        retailers: [...state.retailers, action.data.retailer],
      };
    case 'REMOVE_RETAILER':
      return {
        ...state,
        retailers: state.retailers.filter(
          (user) => user.key !== action.data.key,
        ),
      };
    case 'CLEAR_RETAILERS':
      return {
        ...state,
        retailers: [],
      };
    case 'SET_ORDER_DETAILS':
      return {
        ...state,
        orderDetails: action.data,
      };

    // Retailers List For Order Details
    case 'SET_ORDER_RETAILER_LIST':
      return {
        ...state,
        retailerListForOrderDetails: action.data,
      };
    case 'SET_BUYER_FOR_SELL_TO_BUYER':
      return { ...state, buyerDetails: action.data };
    case 'ADD_RETAILER_FOR_ORDER':
      return {
        ...state,
        retailerListForOrderDetails: [
          ...state.retailerListForOrderDetails,
          action.data.retailer,
        ],
      };

    // Navbar distapch status toggle
    case 'SET_DISPATCH_STATUS_TAB':
      return {
        ...state,
        dispatchStatusTab: action.data,
      };

    // Navbar distapch status toggle
    case 'SET_ORDER_TAB':
      return {
        ...state,
        orderTab: action.data,
      };

    // Add User Data In Dispatch Planning
    case 'ADD_USER_DATA':
      return {
        ...state,
        dataForAddUserInDispatchPlanning: action.data,
      };

    // Product Price page
    case 'SET_PRODUCT_PRICE_VISIBLE':
      return { ...state, productPriceVisibility: action.data };

    // Retailer Associate Order Placing
    case 'SET_ORDER_DETAILS_FOR_RETAILER_ASSOCIATE':
      return {
        ...state,
        orderForRetailerAndAssociate: action.data,
      };

    case 'SET_ORDER_PRODUCTS_FOR_RETAILER_ASSOCIATE':
      return {
        ...state,
        productsForRetailerAndAssociate: action.data,
      };
      case 'ADD_TO_CART': {
        // Check if the item is already in the cart
        const existingIndex = state.cart.findIndex(
          (item) => item.product_id === action.payload.product_id
        );
  
        if (existingIndex !== -1) {
          // If item is already in cart, update quantity
          const updatedItems = [...state.cart];
          updatedItems[existingIndex].qty =
            Number(updatedItems[existingIndex].qty) + Number(action.payload.qty);
          return { ...state, cart: updatedItems };
        } else {
          // If item is not in cart, add it
          return {
            ...state,
            cart: [...state.cart, action.payload],
          };
        }
      }
  
      case 'INCREMENT':
        const arr = state.cart;
        return {
          ...state,
          cart: arr.map((prev) => {
           
            if (prev.product_id === action.payload.product_id) {
              return {
                ...prev,
                qty: Number(prev.qty) + 1,
              };
            } else {
              return prev;
            }
          }),
        };
  
      case 'DECREMENT': {
        const arr = state.cart;
        return {
          ...state,
          cart: arr.map((prev) => {
            if (prev.product_id === action.payload.product_id) {
              return {
                ...prev,
                qty: Number(prev.qty) - 1,
              };
            } else {
              return prev;
            }
          }),
        };
      }
      case 'REMOVE_FROM_CART': {
        return {
          ...state,
          cart: state.cart.filter(
            (prev) => prev.product_id !== action.payload.product_id
          ),
        };
      }
      case 'REPLACE_PRODUCT_IN_CART': {
        const arr1 = state.cart.splice(state.cart.findIndex((prev) => prev.product_id === action.payload.product_id), 1, action.payload);
        return {
          ...state,
          cart: arr1
        };
      }
      case 'CLEAR_CART': {
        return {
          ...state,
          cart: [],
        };
      }
      case 'CLEAR_CART': {
        return {
          ...state,
          cart: [],
        };
      }
      case 'SET_SEC_CART': {
        return { ...state, sec_cart: [...action.data] };
      }
      case 'SEC_ADD_TO_CART': {
        // Check if the item is already in the cart
        const existingIndex = state.sec_cart.findIndex(
          (item) => item.product_id === action.payload.product_id
        );
  
        if (existingIndex !== -1) {
          // If item is already in cart, update quantity
          const updatedItems = [...state.sec_cart];
          updatedItems[existingIndex].qty =
            Number(updatedItems[existingIndex].qty) + Number(action.payload.qty);
          return { ...state, sec_cart: updatedItems };
        } else {
          // If item is not in cart, add it
          return {
            ...state,
            sec_cart: [...state.sec_cart, action.payload],
          };
        }
      }
  
      case 'SEC_INCREMENT': {
        const arr = state.sec_cart;
        return {
          ...state,
          sec_cart: arr.map((prev) => {
            if (prev.product_id === action.payload.product_id) {
              return {
                ...prev,
                qty: Number(prev.qty) + 1,
              };
            } else {
              return prev;
            }
          }),
        };
      }
  
      case 'SEC_DECREMENT': {
        const arr = state.sec_cart;
        return {
          ...state,
          sec_cart: arr.map((prev) => {
            if (prev.product_id === action.payload.product_id) {
              return {
                ...prev,
                qty: Number(prev.qty) - 1,
              };
            } else {
              return prev;
            }
          }),
        };
      }
      case 'SEC_REMOVE_FROM_CART': {
        return {
          ...state,
          sec_cart: state.sec_cart.filter(
            (prev) => prev.product_id !== action.payload.product_id
          ),
        };
      }
      case 'SEC_CLEAR_CART': {
        return {
          ...state,
          sec_cart: [],
        };
      }
  
      case 'SAVE_ADDRESS': {
        return {
          ...state,
          deliveryAddressDetails: action.address,
        };
      }
      case 'SELECT_SELLER_COMPANY': {
        return {
          ...state,
          company_id: action.company_id,
        };
      }
      case 'SET_CASH_DISCOUNT_CONFIG': {
        return {
          ...state,
          cashDiscountConfig: action.cashDiscountConfig
        };
      }
      case 'STORE_COMPANY_DETAILS': {
        return {
          ...state,
          companyDetails: action.companyDetails,
        };
      }
      case 'SELECT_DISTRIBUTOR_FOR_SECONDARY_ORDER': {
        return {
          ...state,
          distributor: action.distributor,
        };
      }

    case 'SET_EWR_PRODUCTS':
      return {
        ...state,
        EWRProductForOrder: action.data,
      };
    case 'SET_SKU_MASTER':
      return { ...state, skuMaster: action.data };
    case 'SET_SKU_ID_MASTER':
        return { ...state, skuIdMaster: action.data };
    case 'SET_CHILD_TO_BASE':
      return { ...state, childToBase: action.data };
    case 'SET_BASE_TO_CHILD':
      return { ...state, baseToChild: action.data };
      

    default:
      return state;
  }
};

export default orderReducer;
